export const selectIsConnected = state => state.network.isConnected

export const selectIsOfflineChecked = state => state.network.isOfflineChecked
